{
  "schemaVersion": 1,
  "evidence": "Original pinned archive samples and client callsites. Later source candidates; exact 2009 capture remains unverified.",
  "ui": {
    "gameOver": {
      "url": "/game/audio/feedback-sounds/Sound040.wav",
      "startOffset": 0,
      "duration": 2.230453514739229
    },
    "win": {
      "url": "/game/audio/feedback-sounds/Sound063.wav",
      "startOffset": 0,
      "duration": 8.25469387755102
    },
    "lose": {
      "url": "/game/audio/feedback-sounds/Sound064.wav",
      "startOffset": 0,
      "duration": 8.228571428571428
    }
  },
  "battle": {
    "walk": {
      "url": "/game/audio/feedback-sounds/Sound044.wav",
      "startOffset": 0,
      "duration": 0.21537414965986396
    },
    "death": {
      "url": "/game/audio/feedback-sounds/Sound042.wav",
      "startOffset": 0,
      "duration": 1.619092970521542
    },
    "charge": {
      "url": "/game/audio/feedback-sounds/Sound020.wav",
      "startOffset": 0,
      "duration": 3.549954648526077
    },
    "release": {
      "url": "/game/audio/feedback-sounds/Sound019.wav",
      "startOffset": 0,
      "duration": 0.6124489795918368
    },
    "aim": {
      "url": "/game/audio/feedback-sounds/Sound006.wav",
      "startOffset": 0,
      "duration": 0.062494331065759634
    }
  },
  "soundIds": {
    "ui": {
      "gameOver": "040",
      "win": "063",
      "lose": "064"
    },
    "battle": {
      "walk": "044",
      "death": "042",
      "charge": "020",
      "release": "019",
      "aim": "006"
    }
  },
  "rules": {
    "walk": "Play only on an actual walk step; reuse the original non-overlapping voice, never layer Sound044 while it is still playing",
    "death": "Play at the presented alive-to-dead transition, including falling out",
    "gameOver": "Play once when the original game-over banner begins",
    "result": "Play Sound063 or Sound064 when the corresponding results presentation begins; catch-up states do not replay old results",
    "angle": "ArrowView plays Sound006 after each manuallySetGunAngle that actually changes the angle, both keyDown and held enterFrame; clamped/no-change attempts remain silent. SoundManager.play defaults allow overlapping new voices, including the 62.49ms clip at 40ms held ticks",
    "buttons": "Start, ready, cancel-ready and room buttons use the original Sound008 already exported by prop-audio.json",
    "charge": "EnergyView.calcForce plays Sound020 without overlapping while charging; release or cancellation stops it",
    "release": "EnergyView.__enterFrame stops Sound020 and plays Sound019 when the spacebar is released; weapon emission is a later independent event"
  }
}
